const baseURL = "/v1/Lotacao";

const service = {
  methods: {
    $buscarLotacoes(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $buscarLotacoesPorPermissao() {
      return this.$api().get(`${baseURL}/PorPermissao`);
    },
    $visualizarLotacao(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarLotacao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarLotacao(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarLotacao(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
